import React, { useCallback, useMemo, useState } from 'react'
import AppContext from './appContext'
import { toast } from 'react-toastify'

// const API_BASE = process.env.REACT_APP_API_BASE || 'https://metatechbeex-dot-arched-gear-433017-u9.de.r.appspot.com'
// const API_BASE = 'https://metatechbeex-dot-arched-gear-433017-u9.de.r.appspot.com'
const API_BASE = 'https://metatech-be.vercel.app'

const AppState = ({ children }) => {
  const [authToken, setAuthToken] = useState(localStorage.getItem('auth-token') || '')
  const [posts, setPosts] = useState([])
  const [portfolios, setPortfolios] = useState([])   // ← NEW

  const setToken = useCallback((token) => {
    setAuthToken(token)
    if (token) localStorage.setItem('auth-token', token)
    else localStorage.removeItem('auth-token')
  }, [])

  // Auth
  const loginAdmin = useCallback(async ({ username, password }) => {
    try {
      const res = await fetch(`${API_BASE}/api/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
      })
      if (!res.ok) throw new Error(await res.text())
      const data = await res.json()
      setToken(data?.authToken || '')
      toast.success('Logged in successfully')
      return true
    } catch (e) {
      toast.error(e?.message || 'Login failed')
      return false
    }
  }, [setToken])

  // Cloudinary image upload
  const uploadImage = useCallback(async (file) => {
    if (!file) return ''
    try {
      const form = new FormData()
      form.append('file', file)
      form.append('upload_preset', 'for_migration')
      const res = await fetch('https://api.cloudinary.com/v1_1/l7pafu4a/image/upload', { method: 'POST', body: form })
      const data = await res.json()
      if (!data?.secure_url) throw new Error('Upload failed')
      toast.success('Image uploaded')
      return data.secure_url
    } catch (e) {
      toast.error(e?.message || 'Image upload failed')
      return ''
    }
  }, [])

  // Posts APIs
  const fetchPosts = useCallback(async () => {
    try {
      const res = await fetch(`${API_BASE}/api/posts`)
      const data = await res.json()
      setPosts(Array.isArray(data) ? data : [])
    } catch {
      toast.error('Failed to load posts')
    }
  }, [])

  const fetchPostById = useCallback(async (id) => {
    const res = await fetch(`${API_BASE}/api/posts/${id}`)
    if (!res.ok) throw new Error('Failed to load post')
    return await res.json()
  }, [])

  const fetchPostBySlug = useCallback(async (slug) => {
    const res = await fetch(`${API_BASE}/api/posts/slug/${encodeURIComponent(slug)}`)
    if (!res.ok) throw new Error('Failed to load post')
    return await res.json()
  }, [])

  const createPost = useCallback(async (payload) => {
    const res = await fetch(`${API_BASE}/api/posts`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'auth-token': authToken },
      body: JSON.stringify(payload)
    })
    if (!res.ok) throw new Error('Failed to create post')
    const created = await res.json()
    toast.success('Post created')
    setPosts((p) => [created, ...p])

    const githubResponse = fetch(
      "https://api.github.com/repos/Ashar-Ahmed11/metatech-official-main/dispatches",
      {
        method: "POST",
        headers: {
          Authorization: "Bearer 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", // Replace with your actual token
          Accept: "application/vnd.github+json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          event_type: "rebuild",
        }),
      }
    );
    // const githubData = await githubResponse.json();
    console.log("GitHub Dispatch Response:", githubResponse);



    
    return created
  }, [authToken])

  const updatePost = useCallback(async (id, payload) => {
    const res = await fetch(`${API_BASE}/api/posts/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', 'auth-token': authToken },
      body: JSON.stringify(payload)
    })
    if (!res.ok) throw new Error('Failed to update post')
    const updated = await res.json()
    toast.success('Post updated')
    setPosts((p) => p.map((x) => (x._id === id ? updated : x)))


    const githubResponse = fetch(
      "https://api.github.com/repos/Ashar-Ahmed11/metatech-official-main/dispatches",
      {
        method: "POST",
        headers: {
          Authorization: "Bearer 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", // Replace with your actual token
          Accept: "application/vnd.github+json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          event_type: "rebuild",
        }),
      }
    );
    // const githubData = await githubResponse.json();
    console.log("GitHub Dispatch Response:", githubResponse);



    return updated
  }, [authToken])

  const deletePost = useCallback(async (id) => {
    const res = await fetch(`${API_BASE}/api/posts/${id}`, {
      method: 'DELETE',
      headers: { 'auth-token': authToken }
    })
    if (!res.ok) throw new Error('Failed to delete post')
    toast.success('Post deleted')
    setPosts((p) => p.filter((x) => x._id !== id))

    const githubResponse = fetch(
      "https://api.github.com/repos/Ashar-Ahmed11/metatech-official-main/dispatches",
      {
        method: "POST",
        headers: {
          Authorization: "Bearer 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", // Replace with your actual token
          Accept: "application/vnd.github+json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          event_type: "rebuild",
        }),
      }
    );
    // const githubData = await githubResponse.json();
    console.log("GitHub Dispatch Response:", githubResponse);


    return true
  }, [authToken])

  // Portfolio APIs  ← NEW
  const fetchPortfolios = useCallback(async () => {
    try {
      const res = await fetch(`${API_BASE}/api/portfolio`)
      const data = await res.json()
      setPortfolios(Array.isArray(data) ? data : [])
    } catch {
      toast.error('Failed to load portfolios')
    }
  }, [])

  const fetchPortfolioById = useCallback(async (id) => {
    const res = await fetch(`${API_BASE}/api/portfolio/${id}`)
    if (!res.ok) throw new Error('Failed to load portfolio')
    return await res.json()
  }, [])

  const createPortfolio = useCallback(async (payload) => {
    const res = await fetch(`${API_BASE}/api/portfolio`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'auth-token': authToken },
      body: JSON.stringify(payload)
    })
    if (!res.ok) throw new Error('Failed to create portfolio')
    const created = await res.json()
    toast.success('Portfolio created')
    setPortfolios((p) => [created, ...p])
    return created
  }, [authToken])

  const updatePortfolio = useCallback(async (id, payload) => {
    const res = await fetch(`${API_BASE}/api/portfolio/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', 'auth-token': authToken },
      body: JSON.stringify(payload)
    })
    if (!res.ok) throw new Error('Failed to update portfolio')
    const updated = await res.json()
    toast.success('Portfolio updated')
    setPortfolios((p) => p.map((x) => (x._id === id ? updated : x)))
    return updated
  }, [authToken])

  const deletePortfolio = useCallback(async (id) => {
    const res = await fetch(`${API_BASE}/api/portfolio/${id}`, {
      method: 'DELETE',
      headers: { 'auth-token': authToken }
    })
    if (!res.ok) throw new Error('Failed to delete portfolio')
    toast.success('Portfolio deleted')
    setPortfolios((p) => p.filter((x) => x._id !== id))
    return true
  }, [authToken])

  const value = useMemo(() => ({
    authToken,
    setToken,
    loginAdmin,
    uploadImage,
    posts,
    fetchPosts,
    fetchPostById,
    fetchPostBySlug,
    createPost,
    updatePost,
    deletePost,
    portfolios,               // ← NEW
    fetchPortfolios,          // ← NEW
    fetchPortfolioById,       // ← NEW
    createPortfolio,          // ← NEW
    updatePortfolio,          // ← NEW
    deletePortfolio           // ← NEW
  }), [
    authToken, setToken, loginAdmin, uploadImage,
    posts, fetchPosts, fetchPostById, fetchPostBySlug, createPost, updatePost, deletePost,
    portfolios, fetchPortfolios, fetchPortfolioById, createPortfolio, updatePortfolio, deletePortfolio
  ])


  console.clear()
  return <AppContext.Provider value={value}>{children}</AppContext.Provider>
}

export default AppState